export const isBrowser =
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof navigator !== 'undefined';

const getEnv = () => (isBrowser ? window.ENV : process.env);

const env = getEnv();

export const NODE_ENV = env?.NODE_ENV || 'development';
export const INSTANCE_ID = Number(env?.INSTANCE_ID) || -1;
export const HASURA_GRAPHQL_URI =
    env?.HASURA_GRAPHQL_URI || 'http://localhost:8080/v1/graphql';
export const HASURA_GRAPHQL_WS_URI =
    env?.HASURA_GRAPHQL_WS_URI || 'ws://localhost:8080/v1/graphql';
export const WEBAPP_ROUTE_PREFIX = env?.WEBAPP_ROUTE_PREFIX || '';
export const PROXY_ENABLED = env?.PROXY_ENABLED === 'true';
export const PROXY_TARGET = env?.PROXY_TARGET || 'http://localhost:8000';
export const POLL_INTERVAL = Number(env?.POLL_INTERVAL) || 60_000; // 1 minute
export const KONG_API_KEY = env?.KONG_API_KEY || undefined;
export const KONG_API_BASE_URL =
    env?.KONG_API_BASE_URL || 'http://localhost:8100/api';
export const SENTRY_DSN = env?.SENTRY_DSN || '';
export const VITE_PUBLIC_POSTHOG_TOKEN =
    env?.VITE_PUBLIC_POSTHOG_TOKEN || undefined;
export const VITE_PUBLIC_POSTHOG_HOST =
    env?.VITE_PUBLIC_POSTHOG_HOST || undefined;
// Reverb (Laravel WebSocket server)
export const REVERB_APP_KEY = env?.REVERB_APP_KEY || '';
export const REVERB_HOST = env?.REVERB_HOST || 'localhost';
export const REVERB_PORT = Number(env?.REVERB_PORT) || 8029;
export const REVERB_SCHEME = env?.REVERB_SCHEME || 'http';
// Modal IDs
export const VARIABLES_MODAL_ID = 'variables-modal';
export const INFRASTRUCTURE_MODAL_ID = 'infrastructure-modal';
export const TASK_TEMPLATES_MODAL_ID = 'task-templates-modal';
export const SYMPTOMS_MODAL_ID = 'symptoms-modal';
export const INFRASTRUCTURE_TYPES_MODAL_ID = 'infrastructure-types-modal';
export const ANOMALIES_WITHOUT_INFRASTRUCTURE_MODAL_ID =
    'anomalies-without-infrastructure-modal';
// Municipalities Modal IDs
export const MUNICIPALITIES_MODAL_ID = 'municipalities-modal';
export const ADD_MUNICIPALITY_MODAL_ID = 'new-municipality-modal';
export const TOTALIZER_VARIABLES_MODAL_ID = 'totalizer-variables-modal';
export const REQUESTS_WITHOUT_COORDINATES_MODAL_ID =
    'requests-without-coordinates-modal';
export const CAUSES_MODAL_ID = 'causes-modal';
export const SCHEDULES_MODAL_ID = 'schedules-modal';
export const INFRASTRUCTURE_VARIABLES_MODAL_ID =
    'infrastructure-variables-modal';
export const INFRASTRUCTURE_ATTRIBUTES_MODAL_ID =
    'infrastructure-attributes-modal';
export const INFRASTRUCTURE_CLIENT_MODAL_ID = 'infrastructure-client-modal';
// Infrastructure name separator used in legacy data
export const INFRASTRUCTURE_NAME_SEPARATOR = '»';

// DnD Grid Constants
export const GRID_COLS = 8;
export const GRID_MAX_ROWS = 8;
